<style lang="scss">
</style>

<template>
    <div class="search-wrap">
        <aside class='search-btn'>
            <ButtonGroup>
                <Button  v-for="(item,index) in btnsearch" size="large" :key="index" :type="formData.EQ_orderStatus===item.value?'primary':'default'" @click="handleBtn('EQ_orderStatus',item.value)">{{item.label}}</Button>
            </ButtonGroup>
        </aside>
        <article class="search-main clearfix">
            <div class="pull-left">
                <Button type="primary" @click="handleModal('add')" icon="md-add">添加</Button>
                <Button type="success" @click="handleModal('upload')">导入</Button>
                <Button @click="handleModal('confirm')">批量确认</Button>
                 <!-- <Dropdown  placement="bottom-start">
                    <Button>
                        更多操作&nbsp;<Icon type="md-arrow-dropdown" />
                    </Button>
                    <DropdownMenu slot="list">
                        <DropdownItem class="splitline" @click.native="handleModal('confirm')">批量确认</DropdownItem>
                    </DropdownMenu>
                </Dropdown> -->
            </div>
            <div class="pull-right">
                <Form :label-width="90" inline>
                     <FormItem label='项目' :label-width="60">
                        <Select clearable v-model="formData.EQ_lineId" filterable >
                            <Option value="">All</Option>
                            <Option value="-1">Others</Option>
                            <Option v-for="item in products" :value="item.id" :key="item.id">{{ item.name }}</Option>
                        </Select>
                    </FormItem>

                    <FormItem label='移库计划单号'>
                        <Input clearable v-model="formData.EQ_tranNo"/>
                    </FormItem>
                    <FormItem label='RemoveOrderID'>
                        <Input clearable v-model="formData.EQ_removeOrderId"/>
                    </FormItem>
                    <FormItem :label-width="1">
                        <Button type="primary" @click="update(false)" icon="ios-search">搜索</Button>
                        <Button @click="update(true)" icon='md-refresh'>重置</Button>
                        <Button type="dashed" @click="isOpen=!isOpen">更多搜索<Icon type="ios-arrow-down" class="margin-left-5"></Icon></Button>
                    </FormItem>
                </Form>
            </div>
        </article>
        <transition name='slide-both'>
            <Form class="search-other" :label-width="80" inline v-show="isOpen">
                <FormItem label='调出仓库'>
                    <Select
                    clearable
                    v-model="formData.EQ_orgwarehouseId"
                    filterable      >
                       <Option v-for="item in amazonWarehouses" :value="item.id" :key="item.id">{{ item.title }}({{ item.code }})</Option>
                    </Select>
                </FormItem>
                <FormItem label='接收仓库'>
                    <Select
                    clearable
                    v-model="formData.EQ_srcOrgwarehouseId"
                    filterable>
                        <Option value="-1">Others</Option>
                       <Option v-for="item in warehouses" :value="item.id" :key="item.id">{{ item.title }}({{ item.code }})</Option>
                    </Select>
                </FormItem>
                <FormItem label='Seller SKU'>
                    <Input clearable v-model="formData.EQ_sellerSkus"/>
                </FormItem>
                <FormItem label='开始时间'>
                    <DatePicker type="date" v-model="formData.GE_orderDate"></DatePicker>
                </FormItem>
                <FormItem label='结束时间'>
                    <DatePicker type="date" v-model="formData.LE_orderDate"></DatePicker>
                </FormItem>
                <FormItem label='单据状态'>
                     <Select clearable v-model="formData.EQ_orderStatus" filterable >
                        <Option v-for="item in btnsearch" :value="item.value" :key="item.value">{{ item.label }}</Option>
                    </Select>
                </FormItem>
                 <!-- <FormItem label='创建人'>
                    <Input clearable v-model="formData.LIKE_createdName"/>
                </FormItem> -->

            </Form>
        </transition>
    </div>
</template>

<script>
import { mapState,mapGetters } from 'vuex';
// import { HttpGroupRuleItem } from '@/service/allotment/transfer'

export default {
    data() {
        return {
            isOpen: false,
            inVslist: [],
            outVslist: [],
            btnsearch: [{
                value: 'establish',
                label: "已创建"
            }, {
                value: 'confirm',
                label: "已确认"
            }, {
                value: 'outdept',
                label: "出库中"
            }, {
                value: 'complete',
                label: "已完成"
            }, {
                value: 'close',
                label: "已取消"
            }, {
                value: null,
                label: "全部"
            }],
            formData: {},
        };
    },
    created() {
        this.formData = { ...this.initForm };
    },
    mounted() {
        this.update();
    },
    computed: {
        ...mapState('boss',['products']),
        ...mapGetters('boss', ['warehouses', 'amazonWarehouses']),
        initForm() {
            return {
                EQ_lineId: '',
                EQ_srcOrgwarehouseId: '',
                EQ_orgwarehouseId: '',
                EQ_tranNo: '',
                EQ_removeOrderId: '',
                EQ_orderStatus:null,
                EQ_sellerSkus: '',
                LE_orderDate: '',
                GE_orderDate: '',
                // LIKE_createdName: '',
            }
        }
    },
    methods: {

        handleModal(type, id) {
            this.$parent.handleOperate(id, type);
        },
        handleBtn(key, val) {
            this.$set(this.formData, key, val);
            this.update();
        },
        update(reset = false) {
            if (reset) this.formData = { ...this.initForm };
            let search = { ...this.formData, LE_orderDate: this.handleDateFormat(this.formData.LE_orderDate, 'yyyy-mm-dd'), GE_orderDate: this.handleDateFormat(this.formData.GE_orderDate, 'yyyy-mm-dd') };
            this.$emit('on-update', { search });
        },
    },
};
</script>
